import React from 'react';
import { useTranslation } from "react-i18next";
import DefaultFooter from "../components/default-footer";
import DefaultHeader from "../components/default-header";

const PaymentGuidelines = () => {
  const { t } = useTranslation();

  return (
    <>
      <style>{`
        /* ── PAYMENT GUIDELINES STYLES ── */
        .payment-wrap {
          background: #fff;
          border-radius: 20px;
          padding: 40px 44px;
          box-shadow: 0 8px 48px rgba(41,75,90,0.10);
        }
        .payment-title {
          font-size: 28px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 8px;
        }
        .payment-subtitle {
          font-size: 14px;
          color: #8aa5b0;
          margin-bottom: 32px;
        }
        .payment-divider {
          height: 2px;
          background: linear-gradient(90deg, #294b5a 0%, #D3BE76 100%);
          border-radius: 2px;
          margin-bottom: 28px;
          width: 80px;
        }
        .payment-section {
          margin-bottom: 32px;
        }
        .payment-section:last-child {
          margin-bottom: 0;
        }
        .payment-section-title {
          font-size: 18px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .payment-section-title .badge {
          font-size: 10px;
          font-weight: 600;
          color: #fff;
          background: #294b5a;
          padding: 2px 10px;
          border-radius: 20px;
          letter-spacing: 0.5px;
        }
        .payment-section p {
          font-size: 14px;
          line-height: 1.8;
          color: #3d5a66;
          margin-bottom: 10px;
        }
        .payment-section ul {
          list-style: none;
          padding: 0;
          margin: 8px 0 0 0;
        }
        .payment-section ul li {
          font-size: 14px;
          line-height: 1.8;
          color: #3d5a66;
          padding-left: 20px;
          position: relative;
          margin-bottom: 4px;
        }
        .payment-section ul li::before {
          content: "•";
          position: absolute;
          left: 0;
          color: #D3BE76;
          font-weight: 700;
        }
        .payment-highlight {
          background: #f7fafc;
          padding: 16px 20px;
          border-radius: 10px;
          border-left: 3px solid #D3BE76;
          margin-top: 6px;
        }
        .payment-highlight p {
          margin-bottom: 0;
        }
        .payment-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 16px;
          margin-top: 8px;
        }
        .payment-card {
          background: #f7fafc;
          padding: 16px 20px;
          border-radius: 10px;
          text-align: center;
          border: 1.5px solid #e8eef1;
          transition: border-color 0.25s, transform 0.25s, box-shadow 0.25s;
        }
        .payment-card:hover {
          border-color: #D3BE76;
          transform: translateY(-4px);
          box-shadow: 0 8px 32px rgba(41,75,90,0.10);
        }
        .payment-card .icon {
          font-size: 32px;
          margin-bottom: 8px;
          display: block;
        }
        .payment-card h4 {
          font-size: 14px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 2px;
        }
        .payment-card p {
          font-size: 12px;
          color: #8aa5b0;
          margin-bottom: 0;
        }
        .payment-card .card-logo {
          font-size: 28px;
          font-weight: 700;
          color: #294b5a;
          letter-spacing: 1px;
        }
        .payment-card .card-logo span {
          color: #D3BE76;
        }

        .payment-steps {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-top: 8px;
        }
        .payment-step {
          background: #f7fafc;
          padding: 16px 20px;
          border-radius: 10px;
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }
        .payment-step .step-number {
          width: 28px;
          height: 28px;
          min-width: 28px;
          border-radius: 50%;
          background: #294b5a;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 700;
        }
        .payment-step .step-content h4 {
          font-size: 13px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 2px;
        }
        .payment-step .step-content p {
          font-size: 13px;
          color: #3d5a66;
          margin-bottom: 0;
          line-height: 1.5;
        }

        .payment-cta {
          background: linear-gradient(135deg, #294b5a 0%, #1a2f38 100%);
          border-radius: 12px;
          padding: 24px 28px;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        }
        .payment-cta h3 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 4px;
        }
        .payment-cta p {
          font-size: 13px;
          opacity: 0.8;
          margin-bottom: 0;
        }
        .payment-cta .cta-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 12px 28px;
          background: #D3BE76;
          color: #1a2f38;
          border: none;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 700;
          text-decoration: none;
          transition: background 0.25s, transform 0.2s;
        }
        .payment-cta .cta-btn:hover {
          background: #c4ae5e;
          transform: translateY(-2px);
        }

        .payment-success {
          background: #e8f5e9;
          border-left: 3px solid #4caf50;
          padding: 16px 20px;
          border-radius: 10px;
          margin-bottom: 10px;
        }
        .payment-success p {
          color: #2e7d32;
          margin-bottom: 0;
        }
        .payment-fail {
          background: #fce4ec;
          border-left: 3px solid #e53935;
          padding: 16px 20px;
          border-radius: 10px;
          margin-bottom: 10px;
        }
        .payment-fail p {
          color: #c62828;
          margin-bottom: 0;
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-weight: 600;
          color: #294b5a;
          text-decoration: none;
          margin-bottom: 24px;
          transition: color 0.2s;
        }
        .back-link:hover {
          color: #D3BE76;
        }
        .back-link svg {
          width: 16px;
          height: 16px;
          stroke: currentColor;
          fill: none;
          stroke-width: 2.5;
        }

        @media (max-width: 768px) {
          .payment-wrap { padding: 28px 20px; }
          .payment-title { font-size: 22px; }
          .payment-grid { grid-template-columns: 1fr 1fr; }
          .payment-steps { grid-template-columns: 1fr; }
          .payment-cta { flex-direction: column; text-align: center; }
        }
        @media (max-width: 480px) {
          .payment-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="header-margin"></div>
      <DefaultHeader />

      <section style={{ paddingTop: '20px' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">

              {/* ── BACK LINK ── */}
              <a href="/" className="back-link">
                <svg viewBox="0 0 24 24">
                  <line x1="19" y1="12" x2="5" y2="12"/>
                  <polyline points="12 19 5 12 12 5"/>
                </svg>
                {t("backToHome", { defaultValue: "Back to Home" })}
              </a>

              {/* ── PAYMENT GUIDELINES CONTENT ── */}
              <div className="payment-wrap">

                {/* Heading */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                  <div style={{ width: "36px", height: "2px", background: "linear-gradient(90deg,#294b5a,#D3BE76)", borderRadius: "2px" }}></div>
                  <span style={{ fontSize: "11px", fontWeight: 700, color: "#294b5a" }}>{t("paymentGuidelines", { defaultValue: "Payment Guidelines" })}</span>
                </div>
                <h1 className="payment-title">{t("paymentTitle", { defaultValue: "Payment Guidelines – OMAN e-Visa" })}</h1>
                <p className="payment-subtitle">{t("paymentSubtitle", { defaultValue: "Welcome to silverjarz.com, your trusted partner for OMAN e-visa services. Please read the following information carefully before proceeding with payment." })}</p>
                <div className="payment-divider"></div>

                {/* ── Section 1: What's Included ── */}
                <div className="payment-section">
                  <div className="payment-section-title">
                    {t("whatsIncluded", { defaultValue: "What's Included in the Payment" })}
                    <span className="badge">{t("coverage", { defaultValue: "Coverage" })}</span>
                  </div>
                  <p>{t("whatsIncludedIntro", { defaultValue: "When applying for a OMAN e-visa through our system, the total cost covers:" })}</p>
                  <ul>
                    <li>{t("included1", { defaultValue: "Processing & Support Fees – To process your application and provide guidance." })}</li>
                    <li>{t("included2", { defaultValue: "OMAN Government & Administrative Fees – Official fees for pre-approval of the visa." })}</li>
                  </ul>
                  <div className="payment-highlight">
                    <p><strong>{t("transparent", { defaultValue: "✅ Transparent Pricing:" })}</strong> {t("transparentText", { defaultValue: "Our transparent pricing ensures you understand exactly what your payment covers." })}</p>
                  </div>
                </div>

                {/* ── Section 2: Payment Options ── */}
                <div className="payment-section">
                  <div className="payment-section-title">
                    {t("paymentOptions", { defaultValue: "Accepted Payment Options" })}
                    <span className="badge">{t("secure", { defaultValue: "Secure" })}</span>
                  </div>
                  <p>{t("paymentOptionsIntro", { defaultValue: "We offer fast, secure online payment processing using major credit and debit cards:" })}</p>

                  <div className="payment-grid">
                    <div className="payment-card">
                      <span className="card-logo">VISA</span>
                      <p>{t("visaCard", { defaultValue: "Credit/Debit" })}</p>
                    </div>
                    <div className="payment-card">
                      <span className="card-logo">MASTER<span>CARD</span></span>
                      <p>{t("mastercard", { defaultValue: "Credit/Debit" })}</p>
                    </div>
                    <div className="payment-card">
                      <span className="card-logo" style={{ fontSize: "22px" }}>AMERICAN<br/><span>EXPRESS</span></span>
                      <p>{t("amex", { defaultValue: "Credit Card" })}</p>
                    </div>
                    <div className="payment-card">
                      <span className="card-logo" style={{ fontSize: "24px" }}>Apple <span>Pay</span></span>
                      <p>{t("applePay", { defaultValue: "Mobile Payment" })}</p>
                    </div>
                    <div className="payment-card">
                      <span className="card-logo" style={{ fontSize: "24px" }}>Google <span>Pay</span></span>
                      <p>{t("googlePay", { defaultValue: "Mobile Payment" })}</p>
                    </div>
                  </div>

                  <div style={{ marginTop: "16px" }}>
                    <p><strong>{t("importantNotes", { defaultValue: "Important Notes:" })}</strong></p>
                    <ul>
                      <li>{t("paymentNote1", { defaultValue: "All payments are processed in US Dollars (USD)" })}</li>
                      <li>{t("paymentNote2", { defaultValue: "Transactions will appear on your statement as: SilverJarz trading contracting" })}</li>
                      <li>{t("paymentNote3", { defaultValue: "You will be required to enter Cardholder Name, Billing Address, Card Number, Expiry Date, and CVV Code" })}</li>
                      <li>{t("paymentNote4", { defaultValue: "3D Secure authentication (OTP from your bank) may be required" })}</li>
                    </ul>
                  </div>
                  <div className="payment-highlight" style={{ borderLeftColor: "#294b5a" }}>
                    <p><strong>{t("security", { defaultValue: "🔒 Security:" })}</strong> {t("securityText", { defaultValue: "We protect your data using TLS encryption and follow PCI DSS standards to ensure transaction security." })}</p>
                  </div>
                </div>

                {/* ── Section 3: Payment Results ── */}
                <div className="payment-section">
                  <div className="payment-section-title">
                    {t("paymentResults", { defaultValue: "Payment Results" })}
                    <span className="badge">{t("outcome", { defaultValue: "Outcome" })}</span>
                  </div>

                  <div className="payment-success">
                    <p><strong>{t("successTitle", { defaultValue: "✅ Payment Successful:" })}</strong> {t("successText", { defaultValue: "A confirmation message will appear on screen. An email confirmation will be sent to you shortly after." })}</p>
                  </div>

                  <div className="payment-fail">
                    <p><strong>{t("failTitle", { defaultValue: "❌ Payment Failed:" })}</strong> {t("failText", { defaultValue: "An error message will be displayed explaining the reason for failure." })}</p>
                  </div>

                  <div className="payment-highlight" style={{ borderLeftColor: "#e53935" }}>
                    <p><strong>{t("importantNote", { defaultValue: "⚠️ Important Note:" })}</strong> {t("importantNoteText", { defaultValue: "All fees are in US Dollars (USD)." })}</p>
                  </div>
                </div>

                {/* ── Section 4: Need Help ── */}
                <div className="payment-section">
                  <div className="payment-section-title">
                    {t("needHelp", { defaultValue: "Need Help?" })}
                    <span className="badge">{t("support", { defaultValue: "Support" })}</span>
                  </div>
                  <p>{t("needHelpText", { defaultValue: "Our customer service team is available 24/7 to assist you with payment-related matters or any questions about your visa application." })}</p>

                  <div className="payment-steps">
                    <div className="payment-step">
                      <div className="step-number">1</div>
                      <div className="step-content">
                        <h4>{t("contactSupport", { defaultValue: "Contact Support" })}</h4>
                        <p>{t("contactSupportText", { defaultValue: "Reach out via WhatsApp, phone, or email for immediate assistance." })}</p>
                      </div>
                    </div>
                    <div className="payment-step">
                      <div className="step-number">2</div>
                      <div className="step-content">
                        <h4>{t("provideOrder", { defaultValue: "Provide Order Details" })}</h4>
                        <p>{t("provideOrderText", { defaultValue: "Have your order number and payment reference ready for faster service." })}</p>
                      </div>
                    </div>
                    <div className="payment-step">
                      <div className="step-number">3</div>
                      <div className="step-content">
                        <h4>{t("resolveIssue", { defaultValue: "Resolve Issues" })}</h4>
                        <p>{t("resolveIssueText", { defaultValue: "Our team will work with you to resolve any payment or application issues." })}</p>
                      </div>
                    </div>
                    <div className="payment-step">
                      <div className="step-number">4</div>
                      <div className="step-content">
                        <h4>{t("confirmation", { defaultValue: "Confirmation" })}</h4>
                        <p>{t("confirmationText", { defaultValue: "You'll receive confirmation once your issue has been resolved." })}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* ── CTA Section ── */}
                <div className="payment-cta">
                  <div>
                    <h3>{t("readyToApply", { defaultValue: "Ready to Apply?" })}</h3>
                    <p>{t("readyToApplyText", { defaultValue: "Start your OMAN e-visa application process today." })}</p>
                  </div>
                  <a href="/visa-application" className="cta-btn">
                    {t("applyNowBtn", { defaultValue: "Apply Now" })}
                    <svg width="16" height="16" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2.5">
                      <line x1="5" y1="12" x2="19" y2="12"/>
                      <polyline points="12 5 19 12 12 19"/>
                    </svg>
                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <DefaultFooter />
    </>
  );
};

export default PaymentGuidelines;